import React, { useState } from 'react';
import './productdetails.css';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Productdetails = ({cardItem, onClose, productType}) => {
    const [cardItemValue] = useState(cardItem);
    const closePopup = () => {    

            onClose();
  
      };
      const hiOffersData = [
        { srNo: 1, question: 'Dampness Inspection', answer: ['Dampness near skirting if gap not filled at floor tile joints','Dampness near window adjustment to wall'
    ,'Dampness near door frames','Dampness near bathroom walls','Dampness at outer wall of apartment if tie hole filling not done properly'
,'Dampness at near fire sprinkler connectivity','Dampness near main electrical DB panel','Dampness near fan points in ceiling','Dampness on ceiling of toilet'] },
{ srNo: 2, question: 'Electrical Inspection', answer: ['Electrical switch boards and plates placement','Checking of electrical wiring','Checking of voltage, earthing and neutral from DB panel','Electric supply in each electrical points','Usage of electrical materials as per standards','Availability of telephone and cable lines','Identification of potential hazard if any','Alignment of each electrical switch board','Fitting components quality check','DB panel connectivity as per standard SLD'] },
{ srNo: 3, question: 'Plumbing Inspection', answer: ['Water leakage in pillar cock, bottle trap, diverter, shower, bath tub spout, jet spray, sink cock','Plumbing line connectors quality','Plumbing inlet and outlet valve connectors','Water pressure','Plumbing material quality','Nahani trap checking for water seal level','Chip offs at washbasin, WC unit, Bath units','Finishing of plumbing items like flush tank, wash basin, WC seat','WC unit size and height as per standards','Gap filling in all plumbing fittings'] },
{ srNo: 4, question: 'Walls and Flooring Inspection', answer: ['Tie hole filling in mivan construction','Cracks or damages on surface of walls','Hollowness in walls','Paint overlapping and paint shade variation','Finishing near columns, skirtings and beam edges','Cracks or scratch marks on surface of tiles','Tiles joint spacing','Hollowness in tiles','Unevenness in tile placement','Slope issues in bathroom, toilet, terrace flooring','Welding spots on tiles'] },
{ srNo: 5, question: 'Doors and Windows Inspection', answer: ['Cracks or damages on door sill, door sanmica, door frame','Door bend issues','Door and door frame edges polish and finishing','Smooth operations of door accessories like door lock, handles, tower bolt, stoppers','Wobbling in doors','Colour shade variation in door sanmica','Rusted door hinges and fitment','Placement and alignment of door accessories','Scratches, cracks and stains on sliding window panels and composite marble','Drain hole availability in window track','Gap filling between composite marble and adjacent wall','Window rubber beading','Functioning of window locking accessories','Functioning of window panel on window tracks','Sealant filling between window track and composite marble'] },
{ srNo: 6, question: 'RERA Carpet Area Verification', answer: ['On site area measurement','Area verification with respect to agreement'] },

      ];
      const services = [
        {
          title: 'Level Strip',
          description: 'Estimation, Planning, Layout Plan, Design & Drawings, Project Planning.',
          iconName: 'https://cdn.snageasy.in/app-img/webp/LevelStrip.webp', // Replace with the actual FontAwesome icon name
        },
        {
            title: 'Digital Multimeter',
            description: 'Residential Projects, Commercial Projects, Amenities, Sewage Treatment Plant, Gardening & Horticulture.',
            iconName: 'https://cdn.snageasy.in/app-img/webp/Multimeter.webp', // Replace with the actual FontAwesome icon name
          },
          {
            title: 'Moisture Meter',
            description: 'Property legal verification for sale & purchage, Liaisoning.',
            iconName: 'https://cdn.snageasy.in/app-img/webp/MoistureMeter.webp', // Replace with the actual FontAwesome icon name
          },
          {
            title: 'Water Pressure Gauge',
            description: 'Structural Audits for residential & commercial projects, Society HOTO',
            iconName: 'https://cdn.snageasy.in/app-img/webp/Waterpressuregauge.webp', // Replace with the actual FontAwesome icon name
          },
          {
            title: 'Infrared Thermometer',
            description: 'Structural Audits for residential & commercial projects, Society HOTO',
            iconName: 'https://cdn.snageasy.in/app-img/webp/InfraredThermometer.webp', // Replace with the actual FontAwesome icon name
          },
          {
            title: 'Foldable Ladder',
            description: 'Structural Audits for residential & commercial projects, Society HOTO',
            iconName: 'https://cdn.snageasy.in/app-img/webp/FoldableLadder.webp', // Replace with the actual FontAwesome icon name
          },
          {
            title: 'Rubber Mallet',
            description: 'Structural Audits for residential & commercial projects, Society HOTO',
            iconName: 'https://cdn.snageasy.in/app-img/webp/Rubbermallet.webp', // Replace with the actual FontAwesome icon name
          },
          {
            title: 'Inspection Mirror',
            description: 'Structural Audits for residential & commercial projects, Society HOTO',
            iconName: 'https://cdn.snageasy.in/app-img/webp/InspectionMirror.webp', // Replace with the actual FontAwesome icon name
          },
          {
            title: 'Flashlight',
            description: 'Structural Audits for residential & commercial projects, Society HOTO',
            iconName: 'https://cdn.snageasy.in/app-img/webp/Flashlight.webp', // Replace with the actual FontAwesome icon name
          },
          {
            title: 'Digital Measuring Tape',
            description: 'Structural Audits for residential & commercial projects, Society HOTO',
            iconName: 'https://cdn.snageasy.in/app-img/webp/Digitalmeasuringtape.webp', // Replace with the actual FontAwesome icon name
          },
        // Add more services as needed
      ];
      const [expandedIndex, setExpandedIndex] = useState(null);

      const toggleAnswer = (index) => {
        setExpandedIndex((prevIndex) => {
          const newIndex = prevIndex === index ? null : index;
          return newIndex;
        });
      };
  return (
    <div className="sng__prd_popup">
      <div className="sng__prd_popup-content">
        <div className="sng__prd_popup-header">
          <span className="close" onClick={closePopup}>&times;</span>
          <h2>{cardItemValue}</h2>
        </div>
        
        <div className="sng__prd_popup-scrollable">
          <h3>Package Includes</h3>
          <div className="package-content">
            {hiOffersData.map((faq, index) => {
              // Show first 5 items for all services, and item 6 only for 'Comprehensive Home Inspection'
              if (faq.srNo < 6 || (faq.srNo === 6 && cardItemValue === 'Comprehensive Home Inspection')) {
                return (
                  <div className="package-item" key={index}>
                    <div 
                      className="package-header" 
                      onClick={() => toggleAnswer(index)}
                    >
                      <span className="package-title">{faq.question}</span>
                      {expandedIndex === index ? (
                        <ExpandLessIcon className="expand-icon" />
                      ) : (
                        <ExpandMoreIcon className="expand-icon" />
                      )}
                    </div>
                    <div className={`package-answer ${expandedIndex === index ? 'expanded' : 'collapsed'}`}>
                      <div className="answer-grid">
                        {faq.answer.map((item, itemIndex) => (
                          <div key={itemIndex} className="answer-item">
                            <CheckCircleIcon className="answer-icon" />
                            <span>{item}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                );
              }
              return null;
            })}
          </div>  
          
          <div className="sng__prd_popup-tools">
            <h3>Inspection Tools</h3>
            <div className="inspection-tool-cards">
              {services.map((service, index) => (
                <div key={index} className='inspection-tool-cards'>
                  <div className='inspection-tool-image'>
                    <img src={service.iconName} alt={service.title}/>
                  </div>
                  <p>{service.title}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Productdetails
